'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createAccount = require('./create-account');

var _createAccount2 = _interopRequireDefault(_createAccount);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CreateAccountTrigger = _react2['default'].createClass({
    displayName: 'CreateAccountTrigger',


    propTypes: {
        'linkText': _react2['default'].PropTypes.string,
        'trigger': _react2['default'].PropTypes.element,
        'triggerSelector': _react2['default'].PropTypes.string,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'redirectUrl': _react2['default'].PropTypes.string,
        'signupUrl': _react2['default'].PropTypes.string,
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'hideRememberMe': _react2['default'].PropTypes.bool,
        'hideGoogleOpenId': _react2['default'].PropTypes.bool,
        'async': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {
        if (window.handlingLogInTriggers) {
            // We only want to process this once per page
            return;
        }
        // If the 'login=1' URL parameter is present, display the modal
        if (/\?display_signup\=1|&display_signup\=1/i.test(location.href)) {
            window.handlingSignupTriggers = true;
            this.handleClick(null);
        }
    },
    handleClick: function handleClick(e) {
        if (e != null) {
            e.preventDefault();
        }
        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('create_account_modal');
        _reactDom2['default'].render(_react2['default'].createElement(_createAccount2['default'], {
            header: this.props.header,
            buttonText: this.props.buttonText,
            googleOpenIdUrl: this.props.googleOpenIdUrl,
            isFromApiPricing: this.props.isFromApiPricing,
            tabOffset: tabOffset,
            redirectUrl: this.props.redirectUrl,
            signupUrl: this.props.signupUrl,
            signupForm: this.props.signupForm,
            loginForm: this.props.loginForm,
            recoverPasswordForm: this.props.recoverPasswordForm,
            hideRememberMe: this.props.hideRememberMe,
            hideGoogleOpenId: this.props.hideGoogleOpenId,
            async: this.props.async }), attachPoint);
    },
    renderTrigger: function renderTrigger() {
        if (this.props.triggerSelector) {
            return _react2['default'].createElement(DOMElementWrapper, { element: this.props.triggerSelector });
        } else if (this.props.trigger) {
            return this.props.trigger;
        } else {
            return _react2['default'].createElement(
                'a',
                { href: '#' },
                this.props.linkText
            );
        }
    },
    render: function render() {
        var trigger = this.renderTrigger();
        return _react2['default'].createElement(
            'span',
            { ref: 'signUpTrigger', className: 'sign-up-trigger', onClick: this.handleClick },
            trigger
        );
    }
});

var DOMElementWrapper = _react2['default'].createClass({
    displayName: 'DOMElementWrapper',
    componentDidMount: function componentDidMount() {
        var signUpTrigger = this.refs.container;
        signUpTrigger.appendChild($(this.props.element)[0]);
    },
    render: function render() {
        return _react2['default'].createElement('span', { ref: 'container' });
    }
});

module.exports = CreateAccountTrigger;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/create-account-trigger.jsx
 ** module id = 883
 ** module chunks = 0
 **/